import React from 'react';

import MyTeams from '../../images/teams.svg';

export const MyTeamsLogo = () => {
  return <img height="18" src={MyTeams} alt="My Teams logo" />;
};
